import { render, staticRenderFns } from "./cass-login-2022.vue?vue&type=template&id=2efcc81b&scoped=true&"
import script from "./cass-login-2022.vue?vue&type=script&lang=js&"
export * from "./cass-login-2022.vue?vue&type=script&lang=js&"
import style0 from "./cass-login-2022.vue?vue&type=style&index=0&id=2efcc81b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efcc81b",
  null
  
)

export default component.exports